export type AllocationInput = {
  propertyId: string;
  amountCents: number;
};

export function allocationTotalCents(allocations: AllocationInput[]) {
  return allocations.reduce((sum, allocation) => sum + allocation.amountCents, 0);
}

export function isFullyAllocated(transactionAmountCents: number, allocations: AllocationInput[]) {
  return allocationTotalCents(allocations) === Math.abs(transactionAmountCents);
}

export function formatCurrency(cents: number) {
  const dollars = cents / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(dollars);
}
